(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4415],{

/***/ 66377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ PostAuthor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _common_Typography_Typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20026);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_hi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53854);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89583);





const SocialLink = (param)=>/*#__PURE__*/ {
    let { href , icon  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: href,
        className: "transition-colors text-copy-on-dark",
        target: "_blank",
        rel: "noreferrer",
        children: icon
    });
};
function PostAuthor(param) {
    let { profilePhoto , firstName , lastName , title , hidePhoto , personalWebsiteLink , twitterLink , githubLink , hideTitle , linkedInLink  } = param;
    var _url;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex gap-3",
        children: [
            !hidePhoto && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "overflow-hidden rounded-full w-12 h-12 border-solid border-[3px] border-divider-on-dark relative",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: (_url = profilePhoto.url) !== null && _url !== void 0 ? _url : "",
                    layout: "fill",
                    alt: "author picture",
                    objectFit: "cover"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col items-start",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_common_Typography_Typography__WEBPACK_IMPORTED_MODULE_1__/* .Typography */ .Z, {
                                type: "copy3",
                                emphasis: true,
                                children: [
                                    firstName,
                                    " ",
                                    lastName
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-wrap gap-2 pointer-events-auto",
                                children: [
                                    personalWebsiteLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SocialLink, {
                                        href: personalWebsiteLink,
                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_3__/* .HiGlobeAlt */ .lKz, {})
                                    }),
                                    twitterLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SocialLink, {
                                        href: twitterLink,
                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_4__/* .FaTwitter */ .fWC, {})
                                    }),
                                    githubLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SocialLink, {
                                        href: githubLink,
                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_4__/* .FaGithub */ .hJX, {})
                                    }),
                                    linkedInLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SocialLink, {
                                        href: linkedInLink,
                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_4__/* .FaLinkedin */ .ltd, {})
                                    })
                                ]
                            })
                        ]
                    }),
                    !hideTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_Typography_Typography__WEBPACK_IMPORTED_MODULE_1__/* .Typography */ .Z, {
                        type: "copy4",
                        className: "text-copy-on-dark",
                        children: title
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 75517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cx": function() { return /* binding */ getTagUrl; },
/* harmony export */   "Md": function() { return /* binding */ PostTag; },
/* harmony export */   "N_": function() { return /* binding */ TagTab; }
/* harmony export */ });
/* unused harmony export SidebarTag */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_hi__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53854);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8193);
/* harmony import */ var react_icons_io__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51649);
/* harmony import */ var _common_Typography_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20026);







const getTagUrl = (slug)=>slug === "all" || !slug ? "/blog" : "/blog/tag/".concat(slug);
function TagIcon(param) {
    let { slug , className  } = param;
    const iconMap = {
        all: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_4__/* .HiCollection */ .CAn, {
            className: className
        }),
        "highlight-engineering": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_4__/* .HiCog */ .oq2, {
            className: className
        }),
        "developer-tooling": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_4__/* .HiTerminal */ .Zbf, {
            className: className
        }),
        "session-replay": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_4__/* .HiPlay */ .bKy, {
            className: className
        }),
        "debugging-and-troubleshooting": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_5__/* .AiFillBug */ .zax, {
            className: className
        }),
        "performance-monitoring": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_6__/* .IoIosStopwatch */ .M66, {
            className: className
        }),
        "frontend-monitoring": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_4__/* .HiChartPie */ .twD, {
            className: className
        })
    };
    var _slug;
    return (_slug = iconMap[slug]) !== null && _slug !== void 0 ? _slug : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_4__/* .HiTag */ .IFg, {
        className: className
    });
}
function PostTag(param) {
    let { name , slug  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: getTagUrl(slug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "rounded-full bg-white/[12%] w-fit px-3 py-0.5 select-none cursor-pointer hover:bg-copy-on-light transition-colors active:bg-black/25 active:transition-none text-copy-on-dark",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_Typography_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .Z, {
                type: "copy4",
                children: name
            })
        })
    });
}
function SidebarTag(param) {
    let { name , slug , current  } = param;
    return /*#__PURE__*/ _jsx(Link, {
        href: getTagUrl(slug),
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex gap-[3px] items-center text-copy-on-dark h-[30px] select-none cursor-pointer transition-all active:transition-none group hover:bg-divider-on-dark/30 active:bg-dark-background pl-[3px]",
            children: [
                /*#__PURE__*/ _jsx(TagIcon, {
                    slug: slug,
                    className: classNames("transition-all  group-hover:text-copy-on-dark", current ? "text-white" : "text-copy-on-light")
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    type: "copy3",
                    className: classNames("transition-all group-hover:opacity-100 group-hover:text-copy-on-dark", current ? "text-white opacity-100" : "opacity-70"),
                    emphasis: current,
                    children: name
                })
            ]
        })
    });
}
function TagTab(param) {
    let { name , slug , current  } = param;
    const tabBaseStyle = classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex gap-2 flex-0 items-center h-[30px] select-none box-content cursor-pointer hover:opacity-100 transition-opacity active:opacity-50 active:transition-none leading-none px-1 pb-2 group border-b-2 border-0 border-solid");
    const tabColorStyle = classnames__WEBPACK_IMPORTED_MODULE_1___default()(current ? "text-highlight-yellow border-highlight-yellow" : "text-copy-on-dark border-transparent");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: getTagUrl(slug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(tabBaseStyle, tabColorStyle),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(current ? "text-highlight-yellow" : "opacity-70 group-hover:opacity-100 transition-opacity", "mt-1"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TagIcon, {
                        slug: slug
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_Typography_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .Z, {
                    type: "copy2",
                    className: "w-max",
                    emphasis: current,
                    children: name
                })
            ]
        })
    });
}


/***/ }),

/***/ 44415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Blog": function() { return /* binding */ Blog; },
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ blog; },
  "loadPostsFromHygraph": function() { return /* binding */ loadPostsFromHygraph; },
  "loadTagsFromHygraph": function() { return /* binding */ loadTagsFromHygraph; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/common/Typography/Typography.tsx
var Typography = __webpack_require__(20026);
// EXTERNAL MODULE: ./components/common/Navbar/Navbar.tsx + 4 modules
var Navbar = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/common/CallToAction/FooterCallToAction.tsx + 1 modules
var FooterCallToAction = __webpack_require__(24035);
// EXTERNAL MODULE: ./components/common/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(5945);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(28687);
// EXTERNAL MODULE: ./node_modules/react-icons/hi/index.esm.js
var index_esm = __webpack_require__(53854);
// EXTERNAL MODULE: ./components/Blog/Tag.tsx
var Tag = __webpack_require__(75517);
;// CONCATENATED MODULE: ./utils/graphql.ts
/* provided dependency */ var process = __webpack_require__(83454);

const graphcms = new dist.GraphQLClient("https://api-us-west-2.graphcms.com/v2/cl2tzedef0o3p01yz7c7eetq8/master", {
    headers: {
        Authorization: "Bearer ".concat(process.env.GRAPHCMS_TOKEN)
    },
    fetch
});
const GraphQLRequest = async function(doc, variables) {
    let delay = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if ( true && delay) {
        // delay hygraph requests during prerendering to avoid too many concurrent requests
        await new Promise((r)=>setTimeout(r, Math.random() * 5000));
    }
    return await graphcms.request(doc, variables);
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/remove-accents/index.js
var remove_accents = __webpack_require__(76826);
var remove_accents_default = /*#__PURE__*/__webpack_require__.n(remove_accents);
;// CONCATENATED MODULE: ./node_modules/match-sorter/dist/match-sorter.esm.js



var rankings = {
  CASE_SENSITIVE_EQUAL: 7,
  EQUAL: 6,
  STARTS_WITH: 5,
  WORD_STARTS_WITH: 4,
  CONTAINS: 3,
  ACRONYM: 2,
  MATCHES: 1,
  NO_MATCH: 0
};
matchSorter.rankings = rankings;

var defaultBaseSortFn = function defaultBaseSortFn(a, b) {
  return String(a.rankedValue).localeCompare(String(b.rankedValue));
};
/**
 * Takes an array of items and a value and returns a new array with the items that match the given value
 * @param {Array} items - the items to sort
 * @param {String} value - the value to use for ranking
 * @param {Object} options - Some options to configure the sorter
 * @return {Array} - the new sorted array
 */


function matchSorter(items, value, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      keys = _options.keys,
      _options$threshold = _options.threshold,
      threshold = _options$threshold === void 0 ? rankings.MATCHES : _options$threshold,
      _options$baseSort = _options.baseSort,
      baseSort = _options$baseSort === void 0 ? defaultBaseSortFn : _options$baseSort,
      _options$sorter = _options.sorter,
      sorter = _options$sorter === void 0 ? function (matchedItems) {
    return matchedItems.sort(function (a, b) {
      return sortRankedValues(a, b, baseSort);
    });
  } : _options$sorter;
  var matchedItems = items.reduce(reduceItemsToRanked, []);
  return sorter(matchedItems).map(function (_ref) {
    var item = _ref.item;
    return item;
  });

  function reduceItemsToRanked(matches, item, index) {
    var rankingInfo = getHighestRanking(item, keys, value, options);
    var rank = rankingInfo.rank,
        _rankingInfo$keyThres = rankingInfo.keyThreshold,
        keyThreshold = _rankingInfo$keyThres === void 0 ? threshold : _rankingInfo$keyThres;

    if (rank >= keyThreshold) {
      matches.push((0,esm_extends/* default */.Z)({}, rankingInfo, {
        item: item,
        index: index
      }));
    }

    return matches;
  }
}
/**
 * Gets the highest ranking for value for the given item based on its values for the given keys
 * @param {*} item - the item to rank
 * @param {Array} keys - the keys to get values from the item for the ranking
 * @param {String} value - the value to rank against
 * @param {Object} options - options to control the ranking
 * @return {{rank: Number, keyIndex: Number, keyThreshold: Number}} - the highest ranking
 */


function getHighestRanking(item, keys, value, options) {
  if (!keys) {
    // if keys is not specified, then we assume the item given is ready to be matched
    var stringItem = item;
    return {
      // ends up being duplicate of 'item' in matches but consistent
      rankedValue: stringItem,
      rank: getMatchRanking(stringItem, value, options),
      keyIndex: -1,
      keyThreshold: options.threshold
    };
  }

  var valuesToRank = getAllValuesToRank(item, keys);
  return valuesToRank.reduce(function (_ref2, _ref3, i) {
    var rank = _ref2.rank,
        rankedValue = _ref2.rankedValue,
        keyIndex = _ref2.keyIndex,
        keyThreshold = _ref2.keyThreshold;
    var itemValue = _ref3.itemValue,
        attributes = _ref3.attributes;
    var newRank = getMatchRanking(itemValue, value, options);
    var newRankedValue = rankedValue;
    var minRanking = attributes.minRanking,
        maxRanking = attributes.maxRanking,
        threshold = attributes.threshold;

    if (newRank < minRanking && newRank >= rankings.MATCHES) {
      newRank = minRanking;
    } else if (newRank > maxRanking) {
      newRank = maxRanking;
    }

    if (newRank > rank) {
      rank = newRank;
      keyIndex = i;
      keyThreshold = threshold;
      newRankedValue = itemValue;
    }

    return {
      rankedValue: newRankedValue,
      rank: rank,
      keyIndex: keyIndex,
      keyThreshold: keyThreshold
    };
  }, {
    rankedValue: item,
    rank: rankings.NO_MATCH,
    keyIndex: -1,
    keyThreshold: options.threshold
  });
}
/**
 * Gives a rankings score based on how well the two strings match.
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @param {Object} options - options for the match (like keepDiacritics for comparison)
 * @returns {Number} the ranking for how well stringToRank matches testString
 */


function getMatchRanking(testString, stringToRank, options) {
  testString = prepareValueForComparison(testString, options);
  stringToRank = prepareValueForComparison(stringToRank, options); // too long

  if (stringToRank.length > testString.length) {
    return rankings.NO_MATCH;
  } // case sensitive equals


  if (testString === stringToRank) {
    return rankings.CASE_SENSITIVE_EQUAL;
  } // Lower casing before further comparison


  testString = testString.toLowerCase();
  stringToRank = stringToRank.toLowerCase(); // case insensitive equals

  if (testString === stringToRank) {
    return rankings.EQUAL;
  } // starts with


  if (testString.startsWith(stringToRank)) {
    return rankings.STARTS_WITH;
  } // word starts with


  if (testString.includes(" " + stringToRank)) {
    return rankings.WORD_STARTS_WITH;
  } // contains


  if (testString.includes(stringToRank)) {
    return rankings.CONTAINS;
  } else if (stringToRank.length === 1) {
    // If the only character in the given stringToRank
    //   isn't even contained in the testString, then
    //   it's definitely not a match.
    return rankings.NO_MATCH;
  } // acronym


  if (getAcronym(testString).includes(stringToRank)) {
    return rankings.ACRONYM;
  } // will return a number between rankings.MATCHES and
  // rankings.MATCHES + 1 depending  on how close of a match it is.


  return getClosenessRanking(testString, stringToRank);
}
/**
 * Generates an acronym for a string.
 *
 * @param {String} string the string for which to produce the acronym
 * @returns {String} the acronym
 */


function getAcronym(string) {
  var acronym = '';
  var wordsInString = string.split(' ');
  wordsInString.forEach(function (wordInString) {
    var splitByHyphenWords = wordInString.split('-');
    splitByHyphenWords.forEach(function (splitByHyphenWord) {
      acronym += splitByHyphenWord.substr(0, 1);
    });
  });
  return acronym;
}
/**
 * Returns a score based on how spread apart the
 * characters from the stringToRank are within the testString.
 * A number close to rankings.MATCHES represents a loose match. A number close
 * to rankings.MATCHES + 1 represents a tighter match.
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @returns {Number} the number between rankings.MATCHES and
 * rankings.MATCHES + 1 for how well stringToRank matches testString
 */


function getClosenessRanking(testString, stringToRank) {
  var matchingInOrderCharCount = 0;
  var charNumber = 0;

  function findMatchingCharacter(matchChar, string, index) {
    for (var j = index, J = string.length; j < J; j++) {
      var stringChar = string[j];

      if (stringChar === matchChar) {
        matchingInOrderCharCount += 1;
        return j + 1;
      }
    }

    return -1;
  }

  function getRanking(spread) {
    var spreadPercentage = 1 / spread;
    var inOrderPercentage = matchingInOrderCharCount / stringToRank.length;
    var ranking = rankings.MATCHES + inOrderPercentage * spreadPercentage;
    return ranking;
  }

  var firstIndex = findMatchingCharacter(stringToRank[0], testString, 0);

  if (firstIndex < 0) {
    return rankings.NO_MATCH;
  }

  charNumber = firstIndex;

  for (var i = 1, I = stringToRank.length; i < I; i++) {
    var matchChar = stringToRank[i];
    charNumber = findMatchingCharacter(matchChar, testString, charNumber);
    var found = charNumber > -1;

    if (!found) {
      return rankings.NO_MATCH;
    }
  }

  var spread = charNumber - firstIndex;
  return getRanking(spread);
}
/**
 * Sorts items that have a rank, index, and keyIndex
 * @param {Object} a - the first item to sort
 * @param {Object} b - the second item to sort
 * @return {Number} -1 if a should come first, 1 if b should come first, 0 if equal
 */


function sortRankedValues(a, b, baseSort) {
  var aFirst = -1;
  var bFirst = 1;
  var aRank = a.rank,
      aKeyIndex = a.keyIndex;
  var bRank = b.rank,
      bKeyIndex = b.keyIndex;
  var same = aRank === bRank;

  if (same) {
    if (aKeyIndex === bKeyIndex) {
      // use the base sort function as a tie-breaker
      return baseSort(a, b);
    } else {
      return aKeyIndex < bKeyIndex ? aFirst : bFirst;
    }
  } else {
    return aRank > bRank ? aFirst : bFirst;
  }
}
/**
 * Prepares value for comparison by stringifying it, removing diacritics (if specified)
 * @param {String} value - the value to clean
 * @param {Object} options - {keepDiacritics: whether to remove diacritics}
 * @return {String} the prepared value
 */


function prepareValueForComparison(value, _ref4) {
  var keepDiacritics = _ref4.keepDiacritics;
  // value might not actually be a string at this point (we don't get to choose)
  // so part of preparing the value for comparison is ensure that it is a string
  value = "" + value; // toString

  if (!keepDiacritics) {
    value = remove_accents_default()(value);
  }

  return value;
}
/**
 * Gets value for key in item at arbitrarily nested keypath
 * @param {Object} item - the item
 * @param {Object|Function} key - the potentially nested keypath or property callback
 * @return {Array} - an array containing the value(s) at the nested keypath
 */


function getItemValues(item, key) {
  if (typeof key === 'object') {
    key = key.key;
  }

  var value;

  if (typeof key === 'function') {
    value = key(item);
  } else if (item == null) {
    value = null;
  } else if (Object.hasOwnProperty.call(item, key)) {
    value = item[key];
  } else if (key.includes('.')) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    return getNestedValues(key, item);
  } else {
    value = null;
  } // because `value` can also be undefined


  if (value == null) {
    return [];
  }

  if (Array.isArray(value)) {
    return value;
  }

  return [String(value)];
}
/**
 * Given path: "foo.bar.baz"
 * And item: {foo: {bar: {baz: 'buzz'}}}
 *   -> 'buzz'
 * @param path a dot-separated set of keys
 * @param item the item to get the value from
 */


function getNestedValues(path, item) {
  var keys = path.split('.');
  var values = [item];

  for (var i = 0, I = keys.length; i < I; i++) {
    var nestedKey = keys[i];
    var nestedValues = [];

    for (var j = 0, J = values.length; j < J; j++) {
      var nestedItem = values[j];
      if (nestedItem == null) continue;

      if (Object.hasOwnProperty.call(nestedItem, nestedKey)) {
        var nestedValue = nestedItem[nestedKey];

        if (nestedValue != null) {
          nestedValues.push(nestedValue);
        }
      } else if (nestedKey === '*') {
        // ensure that values is an array
        nestedValues = nestedValues.concat(nestedItem);
      }
    }

    values = nestedValues;
  }

  if (Array.isArray(values[0])) {
    // keep allowing the implicit wildcard for an array of strings at the end of
    // the path; don't use `.flat()` because that's not available in node.js v10
    var result = [];
    return result.concat.apply(result, values);
  } // Based on our logic it should be an array of strings by now...
  // assuming the user's path terminated in strings


  return values;
}
/**
 * Gets all the values for the given keys in the given item and returns an array of those values
 * @param item - the item from which the values will be retrieved
 * @param keys - the keys to use to retrieve the values
 * @return objects with {itemValue, attributes}
 */


function getAllValuesToRank(item, keys) {
  var allValues = [];

  for (var j = 0, J = keys.length; j < J; j++) {
    var key = keys[j];
    var attributes = getKeyAttributes(key);
    var itemValues = getItemValues(item, key);

    for (var i = 0, I = itemValues.length; i < I; i++) {
      allValues.push({
        itemValue: itemValues[i],
        attributes: attributes
      });
    }
  }

  return allValues;
}

var defaultKeyAttributes = {
  maxRanking: Infinity,
  minRanking: -Infinity
};
/**
 * Gets all the attributes for the given key
 * @param key - the key from which the attributes will be retrieved
 * @return object containing the key's attributes
 */

function getKeyAttributes(key) {
  if (typeof key === 'string') {
    return defaultKeyAttributes;
  }

  return (0,esm_extends/* default */.Z)({}, defaultKeyAttributes, key);
}
/*
eslint
  no-continue: "off",
*/



// EXTERNAL MODULE: ./components/Blog/Author.tsx
var Author = __webpack_require__(66377);
// EXTERNAL MODULE: ./components/Blog/Blog.module.scss
var Blog_module = __webpack_require__(50848);
var Blog_module_default = /*#__PURE__*/__webpack_require__.n(Blog_module);
;// CONCATENATED MODULE: ./pages/blog/index.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query GetPosts() {\n        posts(\n          orderBy: postedAt_DESC\n          where: { unlisted: false }\n          ) {\n            slug\n            title\n            publishedAt\n            postedAt\n            readingTime\n            featured\n            image {\n              url\n            }\n            author {\n              firstName\n              lastName\n              title\n              twitterLink\n              linkedInLink\n              githubLink\n              personalWebsiteLink\n              profilePhoto {\n                url\n              }\n            }\n            tags_relations {\n              name\n              slug\n            }\n          }\n      }\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetTags() {\n      tags {\n        name\n        description\n        slug\n      }\n    }\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}


















var __N_SSG = true;
async function loadPostsFromHygraph(tag) {
    const QUERY = (0,dist.gql)(_templateObject());
    const { posts  } = await GraphQLRequest(QUERY, {
        tag: tag ? [
            tag
        ] : []
    });
    return posts.filter((p)=>tag ? p.tags_relations.some((t)=>t.slug === tag) : true);
}
async function loadTagsFromHygraph() {
    const tagsQuery = (0,dist.gql)(_templateObject1());
    return (await GraphQLRequest(tagsQuery)).tags;
}
const allTag = {
    name: "All posts",
    slug: "all",
    description: "Welcome to the Highlight Blog, where the Highlight team talks about frontend engineering, observability and more!"
};
// https://usehooks-ts.com/react-hook/use-debounce
function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0,react.useState)(value);
    (0,react.useEffect)(()=>{
        const timer = setTimeout(()=>setDebouncedValue(value), delay || 500);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
const Blog = (param)=>{
    let { posts , tags , currentTagSlug  } = param;
    var _page;
    const pageQuery = (_page = (0,router.useRouter)().query.page) !== null && _page !== void 0 ? _page : "1";
    let page = 1;
    if (Array.isArray(pageQuery)) page = parseInt(pageQuery[0]);
    else page = parseInt(pageQuery);
    const shownTags = [
        allTag,
        ...tags
    ];
    var ref;
    const currentTag = (ref = tags.find((param)=>{
        let { slug  } = param;
        return slug === currentTagSlug;
    })) !== null && ref !== void 0 ? ref : allTag;
    const [searchQuery, setSearchQuery] = (0,react.useState)("");
    const debouncedSearchQuery = useDebounce(searchQuery, 300);
    const itemsPerPage = 4;
    const shouldFeature = !debouncedSearchQuery && currentTag.slug === allTag.slug && page <= 1;
    const filteredPosts = debouncedSearchQuery ? matchSorter(posts, debouncedSearchQuery, {
        keys: [
            "title",
            {
                key: "tags_relations.name",
                maxRanking: matchSorter.rankings.CONTAINS
            }
        ]
    }) : posts;
    page = Math.ceil(Math.min(page, filteredPosts.length / itemsPerPage));
    const displayedPosts = debouncedSearchQuery ? filteredPosts : filteredPosts.slice(itemsPerPage * (page - 1), itemsPerPage * page);
    const isStartupStack = currentTag.slug.includes("stack");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-row w-full gap-8 my-20 desktop:max-w-[1100px] mx-auto items-start px-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            /* Main Side */ className: "flex flex-col flex-1 w-full gap-11",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    /* Category Description */ className: "flex flex-col items-start gap-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            children: isStartupStack ? "Welcome to the Startup Stack!" : currentTag.name
                                        }),
                                        isStartupStack ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                                            className: (Blog_module_default()).copyOnDark,
                                            type: "copy1",
                                            children: [
                                                "This is where we talk about the tools and tech you can use to build your next Startup! Read through our episodes below or find us",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "https://www.youtube.com/channel/UCATzQs36Mo7Cezt5Ij9ayZQ",
                                                    children: "on YouTube"
                                                }),
                                                "."
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy1",
                                            className: (Blog_module_default()).copyOnDark,
                                            children: currentTag.description || allTag.description
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    /* Search and Posts */ className: "flex flex-col gap-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            /* Tags Tabs */ className: "flex gap-8 overflow-x-scroll scrollbar-hidden",
                                            children: shownTags.map((tag)=>/*#__PURE__*/ (0,react.createElement)(Tag/* TagTab */.N_, {
                                                    ...tag,
                                                    key: tag.slug,
                                                    current: currentTag.slug === tag.slug
                                                }))
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            /* Search and Pagination */ className: "flex flex-col justify-between w-full gap-4 mobile:flex-row",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                /* Search */ className: "flex items-center flex-grow gap-1 px-2 transition-colors border rounded-lg text-copy-on-dark border-divider-on-dark focus-within:border-copy-on-light h-11",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HiOutlineSearch */.O6C, {
                                                        className: "w-5 h-5 text-copy-on-light"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        placeholder: currentTag.slug === "all" ? "Search all posts..." : "Search all ".concat(currentTag.name, " posts..."),
                                                        value: searchQuery,
                                                        onChange: (ev)=>setSearchQuery(ev.currentTarget.value),
                                                        className: "h-full flex-1 leading-none bg-transparent outline-none text-copy-on-dark text-[17px] w-0"
                                                    })
                                                ]
                                            })
                                        }),
                                        displayedPosts.map((post)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: isStartupStack ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EpisodeItem, {
                                                    post: post
                                                }, post.slug) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PostItem, {
                                                    post: post
                                                }, post.slug)
                                            });
                                        }),
                                        displayedPosts.length < 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy2",
                                            className: "my-10 text-center text-copy-on-light",
                                            children: "No Posts Found"
                                        }),
                                        displayedPosts.length > 0 && !debouncedSearchQuery && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageController, {
                                            page: page,
                                            count: filteredPosts.length / itemsPerPage,
                                            tag: currentTag.slug
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterCallToAction/* FooterCallToAction */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};
function PageController(param) {
    let { page , count , tag  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-row items-center self-center h-9",
        children: [
            page <= 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                type: "copy3",
                emphasis: true,
                className: "grid h-full w-[94px] border border-current rounded-l-md place-items-center text-copy-on-light select-none",
                children: "Previous"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "".concat((0,Tag/* getTagUrl */.Cx)(tag), "?page=").concat(page - 1 || 1),
                className: "grid h-full w-[94px] border border-current rounded-l-md place-items-center",
                children: "Previous"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                type: "copy3",
                className: "grid h-full px-3 border-y text-copy-on-light border-divider-on-dark place-items-center",
                children: [
                    page,
                    " / ",
                    Math.ceil(count)
                ]
            }),
            page >= Math.ceil(count) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                type: "copy3",
                emphasis: true,
                className: "grid h-full w-[94px] border border-current rounded-r-md place-items-center text-copy-on-light select-none",
                children: "Next"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "".concat((0,Tag/* getTagUrl */.Cx)(tag), "?page=").concat(page + 1 || 1),
                className: "grid h-full w-[94px] border border-current rounded-r-md place-items-center",
                children: "Next"
            })
        ]
    });
}
function getDateAndReadingTime(postedAt, readingMinutes) {
    const postedDate = new Date(postedAt).toLocaleDateString(undefined, {
        month: "short",
        day: "numeric",
        year: "numeric"
    });
    return "".concat(postedDate, " • ").concat(readingMinutes, " min. read");
}
const postItemStyle = classnames_default()("relative w-full gap-3 transition-colors border border-solid rounded-lg bg-dark-background p-7 hover:bg-divider-on-dark border-divider-on-dark hover:border-copy-on-light");
const EpisodeItem = (param)=>{
    let { post  } = param;
    var ref, ref1;
    const firstTag = post.tags_relations[0];
    var _readingTime, _readingTime1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden mobile:block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "row",
                        border: "1px solid #30294E",
                        padding: 24,
                        borderRadius: 8,
                        gap: 24
                    },
                    children: [
                        (post === null || post === void 0 ? void 0 : (ref = post.image) === null || ref === void 0 ? void 0 : ref.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            style: {
                                borderRadius: 8,
                                border: "2px solid #30294E",
                                height: 100 * 1.5,
                                width: 190 * 1.5
                            },
                            src: (ref1 = post.image) === null || ref1 === void 0 ? void 0 : ref1.url,
                            alt: "podcast image",
                            height: 100,
                            width: 190
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                    type: "copy4",
                                    className: "text-copy-on-dark",
                                    children: getDateAndReadingTime(post.postedAt, (_readingTime = post.readingTime) !== null && _readingTime !== void 0 ? _readingTime : 0)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/blog/".concat(post.slug),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        className: "mt-1",
                                        children: post.title
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-3",
                                    children: post.author ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Author/* PostAuthor */.M, {
                                        hideTitle: true,
                                        hidePhoto: true,
                                        ...post.author
                                    }) : "Missing Post Author!"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("mobile:hidden block"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        border: "1px solid #30294E",
                        padding: 24,
                        borderRadius: 8,
                        gap: 24
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            firstTag && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* PostTag */.Md, {
                                ...firstTag
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/blog/".concat(post.slug),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "mt-3",
                                    children: post.title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                type: "copy4",
                                className: "mt-1 text-copy-on-dark",
                                children: getDateAndReadingTime(post.postedAt, (_readingTime1 = post.readingTime) !== null && _readingTime1 !== void 0 ? _readingTime1 : 0)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-6",
                                children: post.author && /*#__PURE__*/ (0,jsx_runtime.jsx)(Author/* PostAuthor */.M, {
                                    ...post.author,
                                    hidePhoto: true
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
const PostItem = (param)=>{
    let { post , feature: featured = false  } = param;
    var ref;
    const firstTag = post.tags_relations[0];
    var _readingTime, _readingTime1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()(postItemStyle, featured && "shadow-[8px_8px_0_0_#5420D1]", "hidden mobile:block"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/blog/".concat(post.slug),
                        className: "absolute inset-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        type: "copy4",
                        className: "text-copy-on-dark",
                        children: getDateAndReadingTime(post.postedAt, (_readingTime = post.readingTime) !== null && _readingTime !== void 0 ? _readingTime : 0)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        className: "mt-1",
                        children: post.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative mt-3 pointer-events-none",
                        children: post.author && /*#__PURE__*/ (0,jsx_runtime.jsx)(Author/* PostAuthor */.M, {
                            ...post.author
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex gap-2.5 absolute right-7 bottom-7",
                        children: (ref = post.tags_relations) === null || ref === void 0 ? void 0 : ref.map((tag)=>/*#__PURE__*/ (0,react.createElement)(Tag/* PostTag */.Md, {
                                ...tag,
                                key: tag.slug
                            }))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()(postItemStyle, featured && "shadow-[8px_8px_0_0_#5420D1]", "mobile:hidden block"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/blog/".concat(post.slug),
                        className: "absolute inset-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                    }),
                    firstTag && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* PostTag */.Md, {
                            ...firstTag
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "mt-3",
                        children: post.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        type: "copy4",
                        className: "mt-1 text-copy-on-dark",
                        children: getDateAndReadingTime(post.postedAt, (_readingTime1 = post.readingTime) !== null && _readingTime1 !== void 0 ? _readingTime1 : 0)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative mt-6 pointer-events-none",
                        children: post.author && /*#__PURE__*/ (0,jsx_runtime.jsx)(Author/* PostAuthor */.M, {
                            ...post.author,
                            hidePhoto: true
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var blog = (Blog);


/***/ }),

/***/ 50848:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blogContainer":"Blog_blogContainer__RcYz1","blogSection":"Blog_blogSection__ob5ix","tagContainer":"Blog_tagContainer__Ca1se","copyOnDark":"Blog_copyOnDark__icLCO","tagHeader":"Blog_tagHeader__koSPS","suggestedBlogPost":"Blog_suggestedBlogPost__5cjSY","cardImage":"Blog_cardImage__XNHLl","cardSection":"Blog_cardSection__b1BFz","suggestedPostTitle":"Blog_suggestedPostTitle__BL5A7","blogPost":"Blog_blogPost___Voip","blogPostSmall":"Blog_blogPostSmall__glYdY","postDateDiv":"Blog_postDateDiv__CpP7p","tagDiv":"Blog_tagDiv__4TCOb","bodyText":"Blog_bodyText___VbtI","avatar":"Blog_avatar__lmA0z","authorDiv":"Blog_authorDiv__OfWDl","authorDescription":"Blog_authorDescription__LHLkW","authorDetails":"Blog_authorDetails__FRlgF","mainBlogPadding":"Blog_mainBlogPadding__fAxBt","mainImage":"Blog_mainImage__io3SO","youtubeEmbed":"Blog_youtubeEmbed__YfQbH","tagSortTitle":"Blog_tagSortTitle__Wn_4G","selectedTag":"Blog_selectedTag__UFOjS","dateDiv":"Blog_dateDiv__eBLrY","postTagDiv":"Blog_postTagDiv___Yc8e","suggestedPostDiv":"Blog_suggestedPostDiv__9_6Vh","suggestedPost":"Blog_suggestedPost__xTA8q","postBodyTop":"Blog_postBodyTop__UvyVH","headerSection":"Blog_headerSection__DLrZP","postBody":"Blog_postBody__v_Dyg","codeBlock":"Blog_codeBlock__KCkc2","codeInline":"Blog_codeInline__1fz_b","postBodyDivider":"Blog_postBodyDivider__4_LDF","otherArticlesHeader":"Blog_otherArticlesHeader__Qz5m8","blogImageContainer":"Blog_blogImageContainer__107eO","blogImage":"Blog_blogImage__Kb_Mj","blogText":"Blog_blogText__MlX8v"};

/***/ }),

/***/ 76826:
/***/ (function(module) {

var characterMap = {
	"À": "A",
	"Á": "A",
	"Â": "A",
	"Ã": "A",
	"Ä": "A",
	"Å": "A",
	"Ấ": "A",
	"Ắ": "A",
	"Ẳ": "A",
	"Ẵ": "A",
	"Ặ": "A",
	"Æ": "AE",
	"Ầ": "A",
	"Ằ": "A",
	"Ȃ": "A",
	"Ç": "C",
	"Ḉ": "C",
	"È": "E",
	"É": "E",
	"Ê": "E",
	"Ë": "E",
	"Ế": "E",
	"Ḗ": "E",
	"Ề": "E",
	"Ḕ": "E",
	"Ḝ": "E",
	"Ȇ": "E",
	"Ì": "I",
	"Í": "I",
	"Î": "I",
	"Ï": "I",
	"Ḯ": "I",
	"Ȋ": "I",
	"Ð": "D",
	"Ñ": "N",
	"Ò": "O",
	"Ó": "O",
	"Ô": "O",
	"Õ": "O",
	"Ö": "O",
	"Ø": "O",
	"Ố": "O",
	"Ṍ": "O",
	"Ṓ": "O",
	"Ȏ": "O",
	"Ù": "U",
	"Ú": "U",
	"Û": "U",
	"Ü": "U",
	"Ý": "Y",
	"à": "a",
	"á": "a",
	"â": "a",
	"ã": "a",
	"ä": "a",
	"å": "a",
	"ấ": "a",
	"ắ": "a",
	"ẳ": "a",
	"ẵ": "a",
	"ặ": "a",
	"æ": "ae",
	"ầ": "a",
	"ằ": "a",
	"ȃ": "a",
	"ç": "c",
	"ḉ": "c",
	"è": "e",
	"é": "e",
	"ê": "e",
	"ë": "e",
	"ế": "e",
	"ḗ": "e",
	"ề": "e",
	"ḕ": "e",
	"ḝ": "e",
	"ȇ": "e",
	"ì": "i",
	"í": "i",
	"î": "i",
	"ï": "i",
	"ḯ": "i",
	"ȋ": "i",
	"ð": "d",
	"ñ": "n",
	"ò": "o",
	"ó": "o",
	"ô": "o",
	"õ": "o",
	"ö": "o",
	"ø": "o",
	"ố": "o",
	"ṍ": "o",
	"ṓ": "o",
	"ȏ": "o",
	"ù": "u",
	"ú": "u",
	"û": "u",
	"ü": "u",
	"ý": "y",
	"ÿ": "y",
	"Ā": "A",
	"ā": "a",
	"Ă": "A",
	"ă": "a",
	"Ą": "A",
	"ą": "a",
	"Ć": "C",
	"ć": "c",
	"Ĉ": "C",
	"ĉ": "c",
	"Ċ": "C",
	"ċ": "c",
	"Č": "C",
	"č": "c",
	"C̆": "C",
	"c̆": "c",
	"Ď": "D",
	"ď": "d",
	"Đ": "D",
	"đ": "d",
	"Ē": "E",
	"ē": "e",
	"Ĕ": "E",
	"ĕ": "e",
	"Ė": "E",
	"ė": "e",
	"Ę": "E",
	"ę": "e",
	"Ě": "E",
	"ě": "e",
	"Ĝ": "G",
	"Ǵ": "G",
	"ĝ": "g",
	"ǵ": "g",
	"Ğ": "G",
	"ğ": "g",
	"Ġ": "G",
	"ġ": "g",
	"Ģ": "G",
	"ģ": "g",
	"Ĥ": "H",
	"ĥ": "h",
	"Ħ": "H",
	"ħ": "h",
	"Ḫ": "H",
	"ḫ": "h",
	"Ĩ": "I",
	"ĩ": "i",
	"Ī": "I",
	"ī": "i",
	"Ĭ": "I",
	"ĭ": "i",
	"Į": "I",
	"į": "i",
	"İ": "I",
	"ı": "i",
	"Ĳ": "IJ",
	"ĳ": "ij",
	"Ĵ": "J",
	"ĵ": "j",
	"Ķ": "K",
	"ķ": "k",
	"Ḱ": "K",
	"ḱ": "k",
	"K̆": "K",
	"k̆": "k",
	"Ĺ": "L",
	"ĺ": "l",
	"Ļ": "L",
	"ļ": "l",
	"Ľ": "L",
	"ľ": "l",
	"Ŀ": "L",
	"ŀ": "l",
	"Ł": "l",
	"ł": "l",
	"Ḿ": "M",
	"ḿ": "m",
	"M̆": "M",
	"m̆": "m",
	"Ń": "N",
	"ń": "n",
	"Ņ": "N",
	"ņ": "n",
	"Ň": "N",
	"ň": "n",
	"ŉ": "n",
	"N̆": "N",
	"n̆": "n",
	"Ō": "O",
	"ō": "o",
	"Ŏ": "O",
	"ŏ": "o",
	"Ő": "O",
	"ő": "o",
	"Œ": "OE",
	"œ": "oe",
	"P̆": "P",
	"p̆": "p",
	"Ŕ": "R",
	"ŕ": "r",
	"Ŗ": "R",
	"ŗ": "r",
	"Ř": "R",
	"ř": "r",
	"R̆": "R",
	"r̆": "r",
	"Ȓ": "R",
	"ȓ": "r",
	"Ś": "S",
	"ś": "s",
	"Ŝ": "S",
	"ŝ": "s",
	"Ş": "S",
	"Ș": "S",
	"ș": "s",
	"ş": "s",
	"Š": "S",
	"š": "s",
	"Ţ": "T",
	"ţ": "t",
	"ț": "t",
	"Ț": "T",
	"Ť": "T",
	"ť": "t",
	"Ŧ": "T",
	"ŧ": "t",
	"T̆": "T",
	"t̆": "t",
	"Ũ": "U",
	"ũ": "u",
	"Ū": "U",
	"ū": "u",
	"Ŭ": "U",
	"ŭ": "u",
	"Ů": "U",
	"ů": "u",
	"Ű": "U",
	"ű": "u",
	"Ų": "U",
	"ų": "u",
	"Ȗ": "U",
	"ȗ": "u",
	"V̆": "V",
	"v̆": "v",
	"Ŵ": "W",
	"ŵ": "w",
	"Ẃ": "W",
	"ẃ": "w",
	"X̆": "X",
	"x̆": "x",
	"Ŷ": "Y",
	"ŷ": "y",
	"Ÿ": "Y",
	"Y̆": "Y",
	"y̆": "y",
	"Ź": "Z",
	"ź": "z",
	"Ż": "Z",
	"ż": "z",
	"Ž": "Z",
	"ž": "z",
	"ſ": "s",
	"ƒ": "f",
	"Ơ": "O",
	"ơ": "o",
	"Ư": "U",
	"ư": "u",
	"Ǎ": "A",
	"ǎ": "a",
	"Ǐ": "I",
	"ǐ": "i",
	"Ǒ": "O",
	"ǒ": "o",
	"Ǔ": "U",
	"ǔ": "u",
	"Ǖ": "U",
	"ǖ": "u",
	"Ǘ": "U",
	"ǘ": "u",
	"Ǚ": "U",
	"ǚ": "u",
	"Ǜ": "U",
	"ǜ": "u",
	"Ứ": "U",
	"ứ": "u",
	"Ṹ": "U",
	"ṹ": "u",
	"Ǻ": "A",
	"ǻ": "a",
	"Ǽ": "AE",
	"ǽ": "ae",
	"Ǿ": "O",
	"ǿ": "o",
	"Þ": "TH",
	"þ": "th",
	"Ṕ": "P",
	"ṕ": "p",
	"Ṥ": "S",
	"ṥ": "s",
	"X́": "X",
	"x́": "x",
	"Ѓ": "Г",
	"ѓ": "г",
	"Ќ": "К",
	"ќ": "к",
	"A̋": "A",
	"a̋": "a",
	"E̋": "E",
	"e̋": "e",
	"I̋": "I",
	"i̋": "i",
	"Ǹ": "N",
	"ǹ": "n",
	"Ồ": "O",
	"ồ": "o",
	"Ṑ": "O",
	"ṑ": "o",
	"Ừ": "U",
	"ừ": "u",
	"Ẁ": "W",
	"ẁ": "w",
	"Ỳ": "Y",
	"ỳ": "y",
	"Ȁ": "A",
	"ȁ": "a",
	"Ȅ": "E",
	"ȅ": "e",
	"Ȉ": "I",
	"ȉ": "i",
	"Ȍ": "O",
	"ȍ": "o",
	"Ȑ": "R",
	"ȑ": "r",
	"Ȕ": "U",
	"ȕ": "u",
	"B̌": "B",
	"b̌": "b",
	"Č̣": "C",
	"č̣": "c",
	"Ê̌": "E",
	"ê̌": "e",
	"F̌": "F",
	"f̌": "f",
	"Ǧ": "G",
	"ǧ": "g",
	"Ȟ": "H",
	"ȟ": "h",
	"J̌": "J",
	"ǰ": "j",
	"Ǩ": "K",
	"ǩ": "k",
	"M̌": "M",
	"m̌": "m",
	"P̌": "P",
	"p̌": "p",
	"Q̌": "Q",
	"q̌": "q",
	"Ř̩": "R",
	"ř̩": "r",
	"Ṧ": "S",
	"ṧ": "s",
	"V̌": "V",
	"v̌": "v",
	"W̌": "W",
	"w̌": "w",
	"X̌": "X",
	"x̌": "x",
	"Y̌": "Y",
	"y̌": "y",
	"A̧": "A",
	"a̧": "a",
	"B̧": "B",
	"b̧": "b",
	"Ḑ": "D",
	"ḑ": "d",
	"Ȩ": "E",
	"ȩ": "e",
	"Ɛ̧": "E",
	"ɛ̧": "e",
	"Ḩ": "H",
	"ḩ": "h",
	"I̧": "I",
	"i̧": "i",
	"Ɨ̧": "I",
	"ɨ̧": "i",
	"M̧": "M",
	"m̧": "m",
	"O̧": "O",
	"o̧": "o",
	"Q̧": "Q",
	"q̧": "q",
	"U̧": "U",
	"u̧": "u",
	"X̧": "X",
	"x̧": "x",
	"Z̧": "Z",
	"z̧": "z",
};

var chars = Object.keys(characterMap).join('|');
var allAccents = new RegExp(chars, 'g');
var firstAccent = new RegExp(chars, '');

var removeAccents = function(string) {	
	return string.replace(allAccents, function(match) {
		return characterMap[match];
	});
};

var hasAccents = function(string) {
	return !!string.match(firstAccent);
};

module.exports = removeAccents;
module.exports.has = hasAccents;
module.exports.remove = removeAccents;


/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ })

}]);